import React,{useCallback,useRef,useState,useEffect} from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import classes from './Carousel.module.css'
import {useNavigate} from 'react-router-dom'
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { EffectFade, Navigation, Pagination,Autoplay } from 'swiper/modules';
import image from '../Assets/image.png'
import image2 from '../Assets/image2.png'
import { GetVideos } from '../Services/ApiFunction';

const Carousel = () => {

  const swiperRef = useRef()

  const [videos,setVideos] = useState();
  const navigate = useNavigate()


  const images=[
//     {img:'s1.webp'},
//     {img:'s2.webp'},
//     {img:'s3.webp'},
//     {img:'s4.webp'},
//     {img:'newbanner6.jpg'},
//     {img:'newbanner7.jpg'},

 {img:"/static/media/bg_profile.9ca7b8a7dd624712aabd.jpg"},


]


  const fetchData=useCallback(
    async() => {
      try{
        const res = await GetVideos();
        // console.log(res)

        const allVideos = Object.values(res).flat();
        // console.log("All Videos:", allVideos);
        

        const shuffled = allVideos.sort(() => 0.5 - Math.random());
        const selectedVideos = shuffled.slice(0, 6); // Pick first 5-6 items
        setVideos(selectedVideos);
      }
      catch(err){

      }
    },
    [],
  )





 
  

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const handleImageClick=(id)=>{
    navigate(`/video/${id}`)
  }


  return (
    <div
      onMouseEnter={() => {
        if (swiperRef.current) {
          swiperRef.current.autoplay.stop(); // Stop autoplay on hover
        }
      }}
      onMouseLeave={() => {
        if (swiperRef.current) {
          swiperRef.current.autoplay.start(); // Resume autoplay on mouse leave
        }
      }} 
    >
    <Swiper
        spaceBetween={30}
        ref={swiperRef}
        navigation={false}
        pagination={{
          clickable: true,
        }}
        autoplay={{
        delay: 2000, // Time in milliseconds between slides
        disableOnInteraction: false, // Keeps autoplay running even after interaction
      }}
        modules={[ Navigation, Pagination,Autoplay]}
        className="mySwiper"
        onSwiper={(swiper) => (swiperRef.current = swiper)}  // Store Swiper instance

      >
      {
        images && 
        images?.map((item,idx)=>(
          
          <SwiperSlide className={classes.slider} key={idx}>
          {/* <img src={`https://eurekacontent.gameit.in/THUMBNAIL/Banner/${item?.img}`} className={classes.img} loading = "lazy" /> */}

          <img src={`${item?.img}`} className={classes.img} loading = "lazy" />

        </SwiperSlide>
          
        ))
      }
        
        
      </Swiper>
      </div>
  )
}

export default Carousel
